import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { defineCustomElements as deckDeckGoHighlightElement } from "@deckdeckgo/highlight-code/dist/loader";
deckDeckGoHighlightElement();
import Layout from '../components/Layout';
import Seo from '../components/Seo';
import Landing from '../components/LandingPage/Landing';

export const IndexPageTemplate = ({
  frontmatter,
}) => (
  <div>
    <Landing frontmatter={frontmatter} />
  </div>
);

IndexPageTemplate.propTypes = {
  frontmatter: PropTypes.object,
};

const IndexPage = ({ data }) => {
  const { frontmatter } = data.markdownRemark;

  const testimonials = frontmatter.testimonials || [];
  const reviews = testimonials.map((t, i) => ({
    '@type': 'Review',
    '@id': `https://ortom.ai/#review-${i}`,
    reviewBody: t.quote,
    author: {
      '@type': 'Person',
      name: t.author,
      ...(t.role ? { jobTitle: t.role } : {}),
    },
    itemReviewed: { '@id': 'https://ortom.ai/#organization' },
    reviewRating: {
      '@type': 'Rating',
      ratingValue: '5',
      bestRating: '5',
    },
  }));

  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      '@id': 'https://ortom.ai/#organization',
      name: 'Ortom',
      url: 'https://ortom.ai',
      logo: 'https://ortom.ai/img/logo/Ortom-Logo.png',
      description: 'Manchester-based AI consultancy helping startups and scaleups build production agentic AI systems and LLM products.',
      founder: {
        '@type': 'Person',
        name: 'Tom Liptrot',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      '@id': 'https://ortom.ai/#localbusiness',
      name: 'Ortom',
      url: 'https://ortom.ai',
      image: 'https://ortom.ai/img/logo/Ortom-Logo.png',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Manchester',
        addressCountry: 'GB',
      },
      priceRange: '$$',
    },
    ...reviews,
  ];

  return (
    <Layout>
      <Seo
        title="AI Consultancy for Startups | Agentic AI & LLM Systems | Ortom"
        description="Manchester-based AI consultancy helping startups and scaleups build production agentic AI systems and LLM products, deployed in the cloud, on-premise or at the edge. Specialist experience in health tech and defence."
        pathname="/"
      >
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      </Seo>
      <IndexPageTemplate
        title={frontmatter.title}
        frontmatter={frontmatter}
      />
    </Layout>
  );
};

IndexPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
};

export default IndexPage;

export const pageQuery = graphql`
  query IndexPageTemplate {
    markdownRemark(frontmatter: { templateKey: { eq: "index-page" } }) {
      frontmatter {
        title
        testimonials {
          quote
          author
          role
        }
        intro {
          tagline
          paragraph
          paragraph2
          paragraph3
          paragraph4
          buttonText
        }
      }
    }
  }
`;
